





























import { BButton, BFormGroup, BFormInput } from "bootstrap-vue";
import { computed, defineComponent } from "@vue/composition-api";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import { ValidationProvider } from "vee-validate";

export default defineComponent({
    components: { ValidationProvider, DescriptionInputCounter, BButton, BFormInput, BFormGroup },
    props: {
        value: {
            required: true,
            type: String,
        },
    },
    setup(props, { emit }) {
        const inputQuickReplyText = computed({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        return { inputQuickReplyText };
    },
});
